import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view on every SPA route change.
// The initial page_view is sent by gtag('config', ...) in index.html.
export const RouteAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const page_path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);
  return null;
};

export default RouteAnalytics;
